import cx from 'classnames';
import { useIntl } from 'react-intl';

import { LocalHeroMark } from '../../../../design-system/components/local-hero/LocalHeroMark';
import { Typography } from '../../../../design-system/components/typography/Typography';

import style from './LocalHeroExplanation.module.css';

type LocalHeroExplanationProps = {
    className?: string;
};

export const LocalHeroExplanation = ({ className }: LocalHeroExplanationProps) => {
    const { formatMessage } = useIntl();
    return (
        <div className={cx(className, style.localHeroExplanation)}>
            <Typography
                className={style.localHeroExplanationTitle}
                as="span"
                scale="secondary-s-bold"
                role="heading"
                aria-level={3}
            >
                {formatMessage({ id: 'global.component.localHeroBanner.title' })}
            </Typography>

            {/* eslint-disable-next-line local-rules/no-global-typography-classes -- ADR-0017: à migrer vers <Typography> */}
            <ul className={cx(style.localHeroExplanationsList, 'font-xs-bold')}>
                <li className={style.localHeroExplanationItem}>
                    <LocalHeroMark />
                    {formatMessage({
                        id: 'global.component.localHeroBanner.expertise',
                    })}
                </li>
                <li className={style.localHeroExplanationItem}>
                    <LocalHeroMark />
                    {formatMessage({
                        id: 'global.component.localHeroBanner.satisfaction',
                    })}
                </li>
                <li className={style.localHeroExplanationItem}>
                    <LocalHeroMark />
                    <p>
                        {formatMessage(
                            { id: 'global.component.localHeroBanner.betterTrips' },
                            {
                                italic: (chunks) => {
                                    return <span className={style.italic}>{chunks}</span>;
                                },
                            },
                        )}
                    </p>
                </li>
            </ul>
        </div>
    );
};
